import css from './index.module.scss';
import { TweenMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import ScrollMagicFn from '@/utils/ScrollMagic';
import A from './components/A';
import H from './components/H';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';

export default function CSR_PC() {
    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined' && typeof ScrollMagic == 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax);
    }
    return (
        <div className={`csr_pc ${css.csr_pc}`}>
            <A />
            <H />
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
        </div>
    );
}
